module.exports = __webpack_public_path__ + "img/ImpulsoFitness_Logo_219.3c6d7d19.png";